module.exports = __webpack_public_path__ + "12a32f04bc9175f8332d289bddab86a3.svg";